import AbstractComponent from './AbstractComponent';
import { scrollingElement } from 'managers/ScrollManager';
import { mqMobile } from 'core/MediaQueries';
import ResizeManager from '../managers/ResizeManager';

class ProjectSticky extends AbstractComponent {
  constructor() {
    super(...arguments);
  }

  initializeBeforeEvents() {
    this.active = 0;
    this.vpZoneY = [0, 0.5];
    this.mql = window.matchMedia(mqMobile);
  }

  bind() {
    super.bind();
    this.handleMobileChange = this.handleMobileChange.bind(this);
  }

  getUI() {
    const ui = super.getUI();
    ui.$anchors = [...ui.$element.querySelectorAll('.project__sticky__anchor .link')];
    ui.$contents = [...ui.$element.querySelectorAll('.project__sticky__content')];
    return ui;
  }

  events(listen) {
    super.events(listen);
    const listener = listen ? 'addListener' : 'removeListener';
    this.mql[listener](this.handleMobileChange);
  }

  handleMobileChange({ matches }) {
    this.isMobile = matches;
  }

  handleResize() {
    this.offsets = this.ui.$contents.map(($content) => {
      const rect = $content.getBoundingClientRect();
      return {
        top: rect.y + scrollingElement.scrollTop,
        height: rect.height,
      };
    });
  }

  handleScroll(scrollTop) {
    const result = this.offsets
      .map((offset, index) => {
        const yA1 = this.isMobile ? 0 : ResizeManager.scrollPaddingTop;
        const yA2 = this.isMobile ? ResizeManager.height : ResizeManager.scrollPaddingTop + 250;
        const yB1 = offset.top - scrollTop;
        const yB2 = yB1 + offset.height;
        return {
          height: Math.max(Math.min(yA2, yB2) - Math.max(yA1, yB1)),
          index,
        };
      })
      .sort((a, b) => b.height - a.height);

    if (result[0]) {
      this.active = result[0].index;
    }
  }

  get active() {
    return this._active;
  }

  set active(index) {
    if (index === this._active) return;

    this._active = index;

    const $active = this.ui.$anchors[index];
    const $content = this.ui.$contents[index];

    if ($active && $content) {
      this.ui.$anchors.forEach(($anchor) => $anchor.classList.remove('is-active'));
      this.ui.$contents.forEach(($anchor) => $anchor.classList.remove('is-active'));
      $active.classList.add('is-active');
      $content.classList.add('is-active');
    }
  }
}

export default ProjectSticky;
